// const header = getHeader();

// export const base = 'http://27.196.144.97:19023/';
export const base = 'http://220.160.52.229:8771/ ';
export const base1 = '/api1/';
export const picUrl = '/images/';
export const isTest = false; // 打包

export const isEncryption = false;
export const basePath = '/management/';
export const allBasePath = getHeader() + basePath;
export const baseURL = `${getHeader()}/`;

// const devMode = process.env.NODE_ENV !== 'production';
// const protocol = process.env.HTTPS === 'true' ? 'https' : 'http';
// if (devMode) {
//   baseURL = `${getHeader()}/`;
// } else {
//   baseURL = `${protocol}://${process.env.BASE_URL}/`;
// }

function getHeader() {
  const head = `${window.location.protocol}//${window.location.host}`;
  return head;
}
